import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 12px;
  z-index: 20;
  display: none;

  div[data-selector='TrackHorizontal'] {
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }

  ${media.sm`
    display: block;
  `}
`
